import { useCurrentStateAndParams, useSref } from '@uirouter/react';

import { queryClient } from '@/react-tools/react-query';
import { useCurrentUser } from '@/react/hooks/useUser';

import { Alert } from '@@/Alert';
import { Link } from '@@/Link';

export function NoAddonAccessView() {
  const { onClick, href } = useSref('portainer.logout');
  const { params } = useCurrentStateAndParams();
  const {
    user: { PortainerAccessDenied: portainerAccessDenied },
  } = useCurrentUser();

  // Set by the add-on gateway when it has no route for the add-on asked for;
  // absent when the user has no add-on to open at all.
  const addon = typeof params.addon === 'string' ? params.addon : '';

  const title = addon ? 'Add-on unavailable' : 'No add-ons available';
  const message = addon
    ? `No add-on named ${addon} is reachable. It may not be installed, or its catalog entry may be missing or invalid.`
    : 'Your team is restricted to add-ons, but none are available to you. Please contact your administrator.';

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <div className="w-full max-w-md">
        <Alert color="warn" title={title}>
          {message}{' '}
          {/* Home would steer a denied user straight back to their add-on. */}
          {!portainerAccessDenied && (
            <>
              <Link to="portainer.home" data-cy="noAddonAccess-home">
                Back to Portainer
              </Link>{' '}
            </>
          )}
          <a
            href={href}
            data-cy="noAddonAccess-logOut"
            onClick={(e) => {
              queryClient.clear();
              onClick(e);
            }}
          >
            Log out
          </a>
        </Alert>
      </div>
    </div>
  );
}
